
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { ConcurLinkedService } from 'app/model/linkedservice/concur.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'ConcurObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Concur_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Concur_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: ConcurLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ConcurObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
